import { useState } from 'react'
import { useIntl } from 'react-intl'
import { brStates } from '@client/utils/statesMap'

export default function useCheckout() {
  const intl = useIntl()

  const [roles] = useState([
    { value: '', name: '' },
    {
      value: 'Trainee_Intern',
      name:
        intl.messages[
          'smb_acquisition_form.fields.role.options.trainee_intern'
        ],
    },
    {
      value: 'Analyst',
      name: intl.messages['smb_acquisition_form.fields.role.options.analyst'],
    },
    {
      value: 'Board Member',
      name:
        intl.messages['smb_acquisition_form.fields.role.options.board_member'],
    },
    {
      value: 'CEO',
      name: intl.messages['smb_acquisition_form.fields.role.options.ceo'],
    },
    {
      value: 'CFO',
      name: intl.messages['smb_acquisition_form.fields.role.options.cfo'],
    },
    {
      value: 'CHRO',
      name: intl.messages['smb_acquisition_form.fields.role.options.chro'],
    },
    {
      value: 'Consultant',
      name:
        intl.messages['smb_acquisition_form.fields.role.options.consultant'],
    },
    {
      value: 'Coordinator',
      name:
        intl.messages['smb_acquisition_form.fields.role.options.coordinator'],
    },
    {
      value: 'Director',
      name: intl.messages['smb_acquisition_form.fields.role.options.director'],
    },
    {
      value: 'Doctor',
      name: intl.messages['smb_acquisition_form.fields.role.options.doctor'],
    },
    {
      value: 'Executive Assistant',
      name:
        intl.messages[
          'smb_acquisition_form.fields.role.options.executive_assistant'
        ],
    },
    {
      value: 'Manager',
      name: intl.messages['smb_acquisition_form.fields.role.options.manager'],
    },
    {
      value: 'Self-Employed',
      name:
        intl.messages['smb_acquisition_form.fields.role.options.self_employed'],
    },
    {
      value: 'Specialist',
      name:
        intl.messages['smb_acquisition_form.fields.role.options.specialist'],
    },
    {
      value: 'Supervisor',
      name:
        intl.messages['smb_acquisition_form.fields.role.options.supervisor'],
    },
    {
      value: 'Vice President',
      name:
        intl.messages[
          'smb_acquisition_form.fields.role.options.vice_president'
        ],
    },
  ])

  const [industries] = useState([
    { value: '', name: '' },
    {
      value: 'Agribusiness',
      name:
        intl.messages[
          'smb_acquisition_form.fields.industry.options.agribusiness'
        ],
    },
    {
      value: 'Airlines',
      name:
        intl.messages['smb_acquisition_form.fields.industry.options.airlines'],
    },
    {
      value: 'Association',
      name:
        intl.messages[
          'smb_acquisition_form.fields.industry.options.association'
        ],
    },
    {
      value: 'Construction',
      name:
        intl.messages[
          'smb_acquisition_form.fields.industry.options.construction'
        ],
    },
    {
      value: 'Consultancy',
      name:
        intl.messages[
          'smb_acquisition_form.fields.industry.options.consultancy'
        ],
    },
    {
      value: 'Consumer Goods',
      name:
        intl.messages[
          'smb_acquisition_form.fields.industry.options.consumer_goods'
        ],
    },
    {
      value: 'Education',
      name:
        intl.messages['smb_acquisition_form.fields.industry.options.education'],
    },
    {
      value: 'Financial Services',
      name:
        intl.messages[
          'smb_acquisition_form.fields.industry.options.financial_services'
        ],
    },
    {
      value: 'Food and Beverage',
      name:
        intl.messages[
          'smb_acquisition_form.fields.industry.options.food_and_beverage'
        ],
    },
    {
      value: 'Government or Public Management',
      name:
        intl.messages[
          'smb_acquisition_form.fields.industry.options.government_or_public_management'
        ],
    },
    {
      value: 'Health',
      name:
        intl.messages['smb_acquisition_form.fields.industry.options.health'],
    },
    {
      value: 'HR, Staffing and Recruiting',
      name:
        intl.messages[
          'smb_acquisition_form.fields.industry.options.hr_staffing_and_recruiting'
        ],
    },
    {
      value: 'Law Firms and Services',
      name:
        intl.messages[
          'smb_acquisition_form.fields.industry.options.law_firms_and_services'
        ],
    },
    {
      value: 'Leisure, Travel and Tourism',
      name:
        intl.messages[
          'smb_acquisition_form.fields.industry.options.leisure_travel_and_tourism'
        ],
    },
    {
      value: 'Logistics and Supply Chain',
      name:
        intl.messages[
          'smb_acquisition_form.fields.industry.options.logistics_and_supply_chain'
        ],
    },
    {
      value: 'Manufacturing and Production',
      name:
        intl.messages[
          'smb_acquisition_form.fields.industry.options.manufacturing_and_production'
        ],
    },
    {
      value: 'Media, Marketing and Advertising',
      name:
        intl.messages[
          'smb_acquisition_form.fields.industry.options.media_marketing_and_advertising'
        ],
    },
    {
      value: 'Miscellaneous',
      name:
        intl.messages[
          'smb_acquisition_form.fields.industry.options.miscellaneous'
        ],
    },
    {
      value: 'NGO/Charity',
      name:
        intl.messages[
          'smb_acquisition_form.fields.industry.options.ngo_charity'
        ],
    },
    {
      value: 'Pharma',
      name:
        intl.messages['smb_acquisition_form.fields.industry.options.pharma'],
    },
    {
      value: 'Professional Services',
      name:
        intl.messages[
          'smb_acquisition_form.fields.industry.options.professional_services'
        ],
    },
    {
      value: 'Retail and Wholesale',
      name:
        intl.messages[
          'smb_acquisition_form.fields.industry.options.retail_and_wholesale'
        ],
    },
    {
      value: 'Self-management',
      name:
        intl.messages[
          'smb_acquisition_form.fields.industry.options.self_management'
        ],
    },
    {
      value: 'Technology',
      name:
        intl.messages[
          'smb_acquisition_form.fields.industry.options.technology'
        ],
    },
    {
      value: 'Telecom',
      name:
        intl.messages['smb_acquisition_form.fields.industry.options.telecom'],
    },
    {
      value: 'Utilities, Energy, and Chemical',
      name:
        intl.messages[
          'smb_acquisition_form.fields.industry.options.utilities_energy_and_chemical'
        ],
    },
  ])

  function stateMapper(state) {
    return brStates[state]
  }

  return {
    stateMapper,
    roles,
    industries,
  }
}
